import { ValidatorFn, Validators } from '@angular/forms';

const emailValidationRegex = new RegExp(
  '^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,7}$'
);

export const emailValidator: ValidatorFn = (control) => {
  if (!!control.value === false) return null;

  return emailValidationRegex.test(control.value) ? null : { validEmail: true };
};

export const EMAIL_VALIDATOR = [Validators.required, emailValidator];
